<template>

    <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" ref="form">

        <input type="hidden" name="stay-on-page" v-model="stayOnPage">

        <div class="form-group" v-if="userHasPermission('machines.serial_number.edit')">
            <label for="name">{{ t.__('Numer seryjny') }}</label>
            <input type="text" class="form-control" id="serial_number" v-model="form.serial_number">
            <span class="error mt-2 text-danger" v-if="form.errors.has('serial_number')" v-text="form.errors.get('serial_number')"></span>
        </div>

        <div class="form-group" v-if="userHasPermission('machines.name.edit')">
            <label for="name">{{ t.__('Nazwa') }}</label>
            <input type="text" class="form-control" id="name" v-model="form.name">
            <span class="error mt-2 text-danger" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
        </div>

        <div class="form-group" v-if="userHasPermission('machines.hostname.show')">
            <label for="hostname">{{ t.__('Nazwa hosta') }}</label>
            <input type="text" class="form-control" id="hostname" :value="form.hostname" disabled>
            <span class="error mt-2 text-danger" v-if="form.errors.has('hostname')" v-text="form.errors.get('hostname')"></span>
        </div>

        <div class="form-group" v-if="userHasPermission('machines.notes.edit')">
            <label for="notes">{{ t.__('Komentarz') }}</label>
            <textarea id="notes" class="form-control" rows="3" v-model="form.notes"></textarea>
            <span class="error mt-2 text-danger" v-if="form.errors.has('notes')" v-text="form.errors.get('notes')"></span>
        </div>

        <div class="form-group" v-if="userHasPermission('machines.settings_fan.edit')">
            <label for="name">{{ t.__('Moc chłodzenia (wiatraczka)') }}</label>
            <input type="number" class="form-control" id="settings_fan" v-model="form.settings_fan" min="0" max="100">
            <span class="error mt-2 text-danger" v-if="form.errors.has('settings_fan')" v-text="form.errors.get('settings_fan')"></span>
        </div>

        <hr class="my-5">

        <div class="form-group mb-5" v-if="userHasPermission('machines.template_id.show')">
            <label for="template_id">{{ t.__('Wczytaj dane z szablony maszyny') }}</label>
            <select class="form-control" id="template_id" v-model="form.template_id" @change="machineTemplateChanged">
                <option :value="null" selected>{{ t.__('Wybierz') }}</option>
                <option v-for="machineTemplatesOption in machineTemplatesOptions" :value="machineTemplatesOption.id">{{ machineTemplatesOption.text }}</option>
            </select>
            <span class="error mt-2 text-danger" v-if="form.errors.has('template_id')" v-text="form.errors.get('template_id')"></span>
            <small class="form-text text-muted">{{ t.__('Wczytanie danych z szablonu maszyny spowoduje nadpisanie aktualnej konfiguracji pakietów oraz menu.') }}</small>
        </div>

        <br>

        <div class="form-group" v-if="userHasPermission('machines.type_id.edit')">
            <label for="type_id">{{ t.__('Typ urządzenia') }}</label>
            <select class="form-control" id="type_id" v-model="form.type_id">
                <option :value="null" disabled selected>{{ t.__('Wybierz') }}</option>
                <option v-for="machineTypesOption in machineTypesOptions" :value="machineTypesOption.id">{{ machineTypesOption.text }}</option>
            </select>
            <span class="error mt-2 text-danger" v-if="form.errors.has('type_id')" v-text="form.errors.get('type_id')"></span>
        </div>

        <div class="form-group" v-if="userHasPermission('machines.machine_groups_ids.edit')">
            <label for="machine_groups_ids">{{ t.__('Grupy maszyn') }}</label>
            <select2 id="machine_groups_ids" :options="machineGroupsOptions" v-model="form.machine_groups_ids" multiple></select2>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="hide_token_machine_groups" v-model="hideTokenMachineGroups">
                <label class="custom-control-label" for="hide_token_machine_groups" style="font-size: 0.875rem; line-height: 1.6;">{{ t.__('Ukryj tokenowe grupy maszyn') }}</label>
            </div>
            <span class="error mt-2 text-danger" v-if="form.errors.has('machine_groups_ids')" v-text="form.errors.get('machine_groups_ids')"></span>
        </div>

        <div class="form-group" v-if="userHasPermission('machines.software_type.edit')">
            <label for="software_type">{{ t.__('Rodzaj oprogramowania') }}</label>
            <select class="form-control" id="software_type" v-model="form.software_type" @change="checkRepoValue">
                <option :value="null" disabled selected>Wybierz</option>
                <option v-for="softwareType in softwareTypeOptions" :value="softwareType.id">{{ softwareType.text }}</option>
            </select>
            <span class="error mt-2 text-danger" v-if="form.errors.has('software_type')" v-text="form.errors.get('software_type')"></span>
        </div>

        <div class="form-group" v-if="userHasPermission('machines.repo.edit')">
            <label for="language">{{ t.__('Repozytorium') }}</label>
            <select class="form-control" id="repo" v-model="form.repo">
                <option :value="null" disabled selected>Wybierz</option>
                <option v-for="repo in availableReposOptions" :value="repo">{{ repo }}</option>
            </select>
            <span class="error mt-2 text-danger" v-if="form.errors.has('repo')" v-text="form.errors.get('repo')"></span>
        </div>

        <div class="mb-4" v-if="userHasPermission('machines.autoupdate.edit')">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="autoupdate" v-model="form.autoupdate">
                <label class="custom-control-label" for="autoupdate" style="font-size: 0.875rem; line-height: 1.6;">{{ t.__('Automatyczne aktualizacje') }}</label>
            </div>
            <span class="error mt-2 text-danger" v-if="form.errors.has('autoupdate')" v-text="form.errors.get('autoupdate')"></span>
        </div>

        <div class="mb-4" v-if="userHasPermission('machines.enable_onevo_cast.edit')">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="enable_onevo_cast" v-model="form.enable_onevo_cast">
                <label class="custom-control-label" for="enable_onevo_cast" style="font-size: 0.875rem; line-height: 1.6;">{{ t.__('Włączone onEVO cast') }}</label>
            </div>
            <span class="error mt-2 text-danger" v-if="form.errors.has('enable_onevo_cast')" v-text="form.errors.get('enable_onevo_cast')"></span>
        </div>

        <div class="form-group" v-if="userHasPermission('machines.language.edit')">
            <label for="language">{{ t.__('Język') }}</label>
            <select2 class="form-control" id="language" v-model="form.language">
                <option :value="null" disabled selected>{{ t.__('Wybierz') }}</option>
                <option v-for="languagesOption in languagesOptions" :value="languagesOption.id" :disabled="languagesOption.id === ''">{{ languagesOption.text }}</option>
            </select2>
            <span class="error mt-2 text-danger" v-if="form.errors.has('language')" v-text="form.errors.get('language')"></span>
        </div>

        <div class="form-group" v-if="userHasPermission('machines.timezone.edit')">
            <label for="timezone">{{ t.__('Strefa czasowa') }}</label>
            <select2 class="form-control" id="timezone" v-model="form.timezone">
                <option :value="null" disabled selected>{{ t.__('Wybierz') }}</option>
                <option v-for="timezoneOption in timezonesOptions" :value="timezoneOption.id">{{ timezoneOption.text }}</option>
            </select2>
            <span class="error mt-2 text-danger" v-if="form.errors.has('timezone')" v-text="form.errors.get('timezone')"></span>
        </div>

    </form>

</template>

<script>

    export default {

        name: 'MachineForm',

        props: [
            'machineInput',
            'machineTemplates',
            'machineTypes',
            'machineGroups',
            'availableRepositories',
            'languages',
            'timezones'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                machine: null,
                machineTemplatesOptions: [],
                machineTypesOptions: [],
                hideTokenMachineGroups: true,
                softwareTypeOptions: [
                    {
                        id: 'funtronic',
                        text: 'Funtronic'
                    },
                    {
                        id: 'active_cues',
                        text: 'Active Cues'
                    }
                ],
                languagesOptions: [],
                timezonesOptions: [],
                form: new Vue.prototype.Form({
                    serial_number: this.machineInput.serial_number,
                    name: this.machineInput.name,
                    template_id: null,
                    type_id: this.machineInput.type_id,
                    hostname: this.machineInput.hostname,
                    notes: this.machineInput.notes,
                    settings_fan: this.machineInput.settings_fan,
                    machine_groups_ids: this.machineInput.machine_groups.map(machineGroups => machineGroups.id),
                    software_type: this.machineInput.software_type,
                    repo: this.machineInput.repo,
                    autoupdate: this.machineInput.autoupdate,
                    enable_onevo_cast: this.machineInput.enable_onevo_cast,
                    language: this.machineInput.language,
                    timezone: this.machineInput.timezone
                }),
                stayOnPage: false
            }
        },

        computed: {
            machineGroupsOptions() {
                let machineGroupsOptions = [];
                this.machineGroups.forEach(machineGroup => {
                    if (this.hideTokenMachineGroups === false || (this.hideTokenMachineGroups === true && machineGroup.is_related_with_token === 0)) {
                        machineGroupsOptions.push({
                            text: machineGroup.name,
                            id: machineGroup.id
                        });
                    }
                });
                return machineGroupsOptions;
            },
            availableReposOptions() {
                if (this.availableRepositories[this.form.software_type] !== undefined) {
                    return this.availableRepositories[this.form.software_type];
                } else {
                    return [];
                }
            }
        },

        beforeMount() {

            this.machine = this.machineInput;

            this.machineTemplates.forEach(machineTemplate => {
                this.machineTemplatesOptions.push({
                    text: machineTemplate.name,
                    id: machineTemplate.id
                });
            });

            this.machineTypes.forEach(machineType => {
                this.machineTypesOptions.push({
                    text: machineType.name,
                    id: machineType.id
                });
            });

            this.languages.forEach(language => {
                this.languagesOptions.push({
                    text: language.name,
                    id: language.code
                });
            });

            this.timezones.forEach(timezone => {
                this.timezonesOptions.push({
                    text: timezone.name,
                    id: timezone.code
                });
            });

            this.checkRepoValue();

        },

        created () {
            this.eventHub.$on('submit-form', (stay) => {
                this.stayOnPage = stay;
                this.onSubmit();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('submit-form')
        },

        methods: {
            onSubmit() {
                this.form.put(route('machine::machines.update', {id: this.machine.id}))
                    .then(response => {
                        if (this.stayOnPage) {
                            this.machine = response.data.machine;
                            this.form.setData({
                                serial_number: this.machine.serial_number,
                                name: this.machine.name,
                                type_id: this.machine.type_id,
                                template_id: null,
                                hostname: this.machine.hostname,
                                notes: this.machine.notes,
                                settings_fan: this.machine.settings_fan,
                                machine_groups_ids: this.machine.machine_groups.map(machineGroups => machineGroups.id),
                                software_type: this.machine.software_type,
                                repo: this.machine.repo,
                                autoupdate: this.machine.autoupdate,
                                enable_onevo_cast: this.machine.enable_onevo_cast,
                                language: this.machine.language,
                                timezone: this.machine.timezone
                            });
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        } else {
                            window.location.href = route('machine::machines.index') + '?status-message=success:' + response.message;
                        }
                    })
                    .catch(response => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak. Sprawdź poprawność danych.'), 'error');
                    });
            },

            machineTemplateChanged() {
                let machineTemplate = this.machineTemplates.find(m => {
                    return m.id === this.form.template_id;
                });
                this.form.type_id = machineTemplate.type_id;
                this.form.machine_groups_ids = machineTemplate.machine_groups.map(machineGroups => machineGroups.id);
                this.form.software_type = machineTemplate.software_type;
                this.form.autoupdate = machineTemplate.autoupdate;
                this.form.language = machineTemplate.language;
                this.form.timezone = machineTemplate.timezone;

                this.checkRepoValue();
            },

            checkRepoValue() {
                if (this.availableRepositories[this.form.software_type] === undefined || !this.availableRepositories[this.form.software_type].includes(this.form.repo)) {
                    this.form.repo = 'prod';
                }
            }
        }
    }

</script>

<style scoped>

    /deep/ .select2-container { width: 100% !important; }

</style>
